<template>
	<div class="app-splash" role="progressbar" aria-busy="true" aria-label="eCOS">
		<img src="/m.eagle/img/portal/logo-white.png" alt="eCOS" class="app-splash__logo" />
		<v-progress-linear indeterminate color="white" rounded class="app-splash__progress" />
	</div>
</template>
